import React from 'react';
import '../styles/navbar.css';
import useWindowDimension from '../hooks/useWindowDimension';
import logo from '../assets/imgs/Voxlink_Logo.png';
import logo_title from '../assets/imgs/Voxlink_white.png';
import english from '../assets/imgs/english.svg';
import twitter from '../assets/imgs/twitter.svg';
import discord from '../assets/imgs/discord.svg';
import twitterD from '../assets/imgs/twitter-dark.svg';
import discordD from '../assets/imgs/discord-dark.svg';
import close from '../assets/imgs/close.svg';
import menuBar from '../assets/imgs/menu-bar.svg';
import { useState } from 'react';


const Navbar = () => {

  const { width, height } = useWindowDimension();
  const [menuClick, setMenuClick] = useState(false);

  const showCard = () => {
    setMenuClick(!menuClick);
  };


  return (
    <nav>
      <div className="logo">
        <img className='logo-icon' src={logo} alt="logo" />
        <img className='logo-title' src={logo_title} alt="logo_title" />
      </div>
      <div className="nav-links">
        <img src={english} alt="eng" />
        <a href="https://www.loom.com/share/a55e5758f26647c9aa29198f4a16951b">Demo</a>
        <a href="https://docs.voxlink.io/">Documentation</a>
        {(width > 640) ?
          <>
            <a href="https://twitter.com/_Voxlink">
              <img className='sm' src={twitter} alt="Twitter" />
            </a>
            <a href="https://discord.gg/nn6yp63F">
              <img className='sm' src={discord} alt="Discord" />
            </a>
          </> :
          <div className="navbar-links-box">
            <img onClick={showCard} src={menuBar} alt="menu-bar" />
            <div className={`navbar-links-card ${menuClick ? '' : 'hide-card'}`}>
              <main>
                <h3>Links</h3>
                <img onClick={showCard} src={close} alt="close" />
              </main>
              <div>
                <a style={{ margin: 0 }} href="https://twitter.com/_Voxlink">
                  <img className='sm' src={twitterD} alt="Twitter" />
                </a>
                <a href="https://discord.gg/nn6yp63F">
                  <img className='sm' src={discordD} alt="Discord" />
                </a>
              </div>

            </div>
          </div>
        }

      </div>
    </nav >
  );
};

export default Navbar;